export default __webpack_public_path__ + "static/media/LogoOnlyRemovedBG.d787990d.png";